import { useCallback, useContext } from 'react';
import { MediaContext } from '@spa/shared/contexts/media';
import { HEADER_HEIGHT } from '@spa/offer/constants/sections';
export var useScrollToSection = function useScrollToSection() {
  var _useContext = useContext(MediaContext),
    is = _useContext.is;
  return useCallback(function (sectionName) {
    var targetElement = document.getElementById(sectionName);
    var containerElement = document.getElementById('photos-modal-wrapper');
    if (!targetElement || !containerElement) return;
    var headerHeight = is.mobile ? HEADER_HEIGHT.mobile : HEADER_HEIGHT.desktop;
    var targetPosition = targetElement.offsetTop - headerHeight;
    containerElement.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }, [is.mobile]);
};